import { Card } from '@digdir/designsystemet-react';

import styled from '../../../../../../styled';

export const CheckboxWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--ds-size-4);
`;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const StyledCard = styled(({ isActive, ...props }) => <Card {...props} />)`
  border-radius: var(--ds-border-radius-md);
  padding: var(--ds-size-4);
  background: ${({ isActive }) =>
    isActive ? 'var(--ds-color-background-tinted)' : `var(--ds-color-background-default)`};
`;
